import { FileText, Sparkles, CheckCircle, MessageSquareQuote } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    Icon: FileText,
    title: "Submit Request",
    desc: "Fill the quote form with photos or call us. Takes under 2 minutes.",
  },
  {
    n: "02",
    Icon: MessageSquareQuote,
    title: "Get Your Quote",
    desc: "Custom estimate emailed back within 24 hours — no high-pressure pitches.",
  },
  {
    n: "03",
    Icon: Sparkles,
    title: "We Clean",
    desc: "Insured, uniformed crew arrives on schedule and gets to work — photo-documented.",
  },
  {
    n: "04",
    Icon: CheckCircle,
    title: "Walk-Through & Done",
    desc: "We don't leave until you're satisfied. Pay only after the final approval.",
  },
];

export const ProcessSection = () => (
  <section className="py-24 lg:py-32 bg-[#050505] relative">
    <div className="absolute inset-0 grain opacity-50 pointer-events-none" />
    <div className="max-w-7xl mx-auto px-6 lg:px-12 relative">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-16 gap-6">
        <Reveal className="max-w-xl">
          <div className="overline text-[#D4AF37] mb-4">How It Works</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white leading-tight">
            Four simple
            <br />
            <span className="gold-grad-text italic">steps.</span>
          </h2>
        </Reveal>
        <Reveal delay={120}>
          <p className="text-white/55 max-w-md text-base leading-relaxed">
            From first message to spotless handoff — designed to be effortless and fully transparent.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 relative">
        {/* Connector line */}
        <div className="hidden lg:block absolute top-12 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />

        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 120}>
            <div className="relative card-surface rounded-2xl p-7 h-full">
              <div className="flex items-start justify-between mb-6">
                <div className="h-12 w-12 rounded-full bg-[#D4AF37] text-black flex items-center justify-center relative z-10">
                  <s.Icon size={20} strokeWidth={1.5} />
                </div>
                <div className="font-serif-display text-4xl text-white/[0.08] leading-none">{s.n}</div>
              </div>
              <h3 className="font-serif-display text-xl text-white">{s.title}</h3>
              <p className="text-white/60 text-sm mt-3 leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
